// extracted by mini-css-extract-plugin
module.exports = {"container":"CredentialSharing-ee_container_lAVVy"};